import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    NewsletterSubscriptionContainer as SourceNewsletterSubscriptionContainer,
    NewsletterSubscriptionDispatcher
} from 'SourceComponent/NewsletterSubscription/NewsletterSubscription.container';
import { showPopup } from 'Store/Popup/Popup.action';
import getStore from 'Util/Store';

/** @namespace Elganso/Component/NewsletterSubscription/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    customer: state.MyAccountReducer.customer
});

/** @namespace Elganso/Component/NewsletterSubscription/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    subscribeToNewsletter: (email, categories) => NewsletterSubscriptionDispatcher.then(
        ({ default: dispatcher }) => dispatcher.subscribeToNewsletter(dispatch, email, categories)
    )
});

/** @namespace Elganso/Component/NewsletterSubscription/Container */
export class NewsletterSubscriptionContainer extends SourceNewsletterSubscriptionContainer {
    static propTypes = {
        ...this.propTypes,
        showCategories: PropTypes.bool
    };

    state = {
        ...this.state,
        isTACAccepted: false,
        checkedCategories: false,
        catHombre: true,
        catMujer: true,
        catZapas: true,
        catNino: true,
        catAccesorios: true
    };

    containerFunctions = {
        ...this.containerFunctions,
        setTACAccepted: this.setTACAccepted.bind(this),
        onCategoriesClick: this.onCategoriesClick.bind(this)
    };

    componentDidUpdate(prevProps) {
        const {
            customer: prevCustomer
        } = prevProps;

        const {
            customer,
            customer: { subscriber_categories = null } = {}
        } = this.props;

        const { checkedCategories } = this.state;

        if (Object.keys(prevCustomer).length === 0 && Object.keys(customer).length !== 0) {
            if (subscriber_categories !== null && subscriber_categories !== '') {
                const {
                    hombre, mujer, zapatillas, nino, accesorios
                } = JSON.parse(subscriber_categories);

                this.setState({
                    checkedCategories: true,
                    catHombre: hombre,
                    catMujer: mujer,
                    catZapas: zapatillas,
                    catNino: nino,
                    catAccesorios: accesorios
                });
            }
        }

        if (!checkedCategories) {
            if (Object.keys(customer).length !== 0 && subscriber_categories !== null && subscriber_categories !== '') {
                const {
                    hombre, mujer, zapatillas, nino, accesorios
                } = JSON.parse(subscriber_categories);

                this.setState({
                    checkedCategories: true,
                    catHombre: hombre,
                    catMujer: mujer,
                    catZapas: zapatillas,
                    catNino: nino,
                    catAccesorios: accesorios
                });
            } else {
                this.setState({ checkedCategories: true });
            }
        }
    }

    containerProps() {
        const { blockPopupConditionsPopup, showCategories } = this.props;
        const {
            catHombre, catMujer, catZapas, catNino, catAccesorios, isTACAccepted
        } = this.state;

        return {
            ...super.containerProps(),
            blockPopupConditionsPopup,
            showCategories,
            catHombre,
            catMujer,
            catZapas,
            catNino,
            catAccesorios,
            isTACAccepted
        };
    }

    setTACAccepted() {
        const { blockPopupConditionsPopup } = this.props;
        const { isTACAccepted } = this.state;

        if (!isTACAccepted && !blockPopupConditionsPopup) {
            this.showPopupNewsletter();
        }

        this.setState(({ isTACAccepted }) => ({
            isTACAccepted: !isTACAccepted
        }));
    }

    showPopupNewsletter() {
        const store = getStore();
        const { dispatch } = store;
        dispatch(showPopup('newsletter_popup', { title: __('ENVIOS Y DEVOLUCIONES') }));
    }

    onCategoriesClick(e) {
        const {
            catHombre, catMujer, catZapas, catNino, catAccesorios
        } = this.state;
        const active = e.target.id;

        if (active === 'catHombre') {
            this.setState({ catHombre: !catHombre });
        } else if (active === 'catMujer') {
            this.setState({ catMujer: !catMujer });
        } else if (active === 'catZapas') {
            this.setState({ catZapas: !catZapas });
        } else if (active === 'catNino') {
            this.setState({ catNino: !catNino });
        } else if (active === 'catAccesorios') {
            this.setState({ catAccesorios: !catAccesorios });
        }
    }

    async onFormSubmit(form, fields) {
        const {
            subscribeToNewsletter,
            allowGuestSubscribe,
            isSignedIn,
            showErrorNotification
        } = this.props;

        const {
            value: email
        } = fields.find(({ name }) => name === 'newsletterEmail') || {};

        if (!allowGuestSubscribe && !isSignedIn) {
            showErrorNotification(
                __('Guests can not subscribe to the newsletter. You must create an account or login to subscribe.')
            );

            return;
        }

        this.setState({ isLoading: true });

        const {
            catHombre, catMujer, catZapas, catNino, catAccesorios
        } = this.state;

        const subscriber_categories = {
            hombre: catHombre,
            mujer: catMujer,
            zapatillas: catZapas,
            nino: catNino,
            accesorios: catAccesorios
        };

        await subscribeToNewsletter(email, JSON.stringify(subscriber_categories))
            .then(this.onFormSubmitDone)
            .catch(this.onFormSubmitDone);
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(NewsletterSubscriptionContainer));
